import {observer} from 'mobx-react'
import styles from '../TasksList/style.css'
import React, {useCallback} from 'react'
import {Icon, IconTypes} from '../../../Buttons'
import {agentCharacteristicTypes} from '../../../../store/Agent'
import {InputField} from '../../../InputForms'
import ConfirmationModal from '../../../ConfirmationModal'
import css from './style.css'
import {debounce} from 'lodash'

@observer
  /**
   * @class
   * @param {{agent, characteristic, editable, localizationStore}} props
   */
class CharItem extends React.Component {
  constructor(props) {
    super(props)
    const {characteristic} = props
    this.state = {
      confirmationModalInfo: null,
      description: characteristic.description,
      index: characteristic.index
    }
  }

  onBlur = e => {
    const {agent, characteristic} = this.props
    const {index, description} = this.state
    let obj = null
    if (e.target.name === 'index') {
      if (characteristic.index !== index) {
        obj = {
          index,
          description: characteristic.description
        }
      }
    } else {
      if (characteristic.description !== description) {
        obj = {
          index: characteristic.index,
          description
        }
      }
    }
    if (obj) {
      agent.editCharacteristicRequest(characteristic.id, obj)
    }
    this.sendOnChange.cancel()
  }

  sendOnChange = debounce(e => {
    console.log(e)
    this.onBlur(e)
  }, 300)

  onChange =  e => {
    if (e.target.name === 'index') {
      this.setState({index: e.target.value})
      e.persist()
      this.sendOnChange(e)
    } else {
      this.setState({description: e.target.value})
    }
  }

  onDelete = () => {
    const {agent, characteristic, localizationStore} = this.props
    this.setState({
      confirmationModalInfo: {
        question: localizationStore.locale.remove_task_question,
        applyAction: () => agent.removeCharacteristicRequest(characteristic.id),
        cancelAction: () => this.setState({confirmationModalInfo: null})
      }
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.characteristic !== this.props.characteristic) {
      const {index, description} = this.props.characteristic
      this.setState({index, description})
    }
  }

  render() {
    const {agent, editable, maxIndex} = this.props
    const {confirmationModalInfo, index, description} = this.state
    const {onBlur, onChange, onDelete} = this
    return <div className={styles.task}>
      <InputField
        min={0}
        max={maxIndex}
        type={'number'}
        style={css.indexField}
        onChange={onChange}
        name={'index'}
        onBlur={onBlur}
        value={index}
        disabled={!editable} />
      <InputField
        type={'textarea'}
        style={css.descriptionField}
        onChange={onChange}
        name={'value'}
        onBlur={onBlur}
        value={description}
        disabled={!editable} />
      <Icon disabled={!editable} type={IconTypes.clear} onClick={onDelete} />
      {confirmationModalInfo &&
      <ConfirmationModal agent={agent}
                         question={confirmationModalInfo.question}
                         onApply={confirmationModalInfo.applyAction}
                         onCancel={confirmationModalInfo.cancelAction} />
      }
    </div>
  }
}

const CharList = observer(function CharList({agent, characteristicType, charList, localizationStore, editable}) {
  const onAddTaskClick = useCallback(() => {
    agent.addCharacteristicRequest({
      type: characteristicType,
      description: ''
    })
  }, [agent, characteristicType])
  const characteristics = charList.sort((a, b) => a.index - b.index).map(characteristic =>
    <CharItem
      key={characteristic.id}
      editable={editable}
      agent={agent}
      maxIndex={charList.length - 1}
      className={styles.task}
      characteristic={characteristic}
      localizationStore={localizationStore}/>)
  return <div className={styles.list}>
    <div className={css.listHeader}>
      <span>
        {localizationStore.locale.characteristics(characteristicType)}
      </span>
      <Icon type={IconTypes.add} onClick={onAddTaskClick} disabled={!editable}/>
    </div>
    <div className={styles.container}>
      {characteristics}
    </div>
  </div>;
})


const CharLists = observer(function CharLists({agent, editable, localizationStore}) {
  if (!agent) {
    return null
  }
  const lists = Object.values(agentCharacteristicTypes).reduce((acc, value) => {
    acc[value] = []
    return acc
  }, {})
  agent.characteristics.forEach(char => {
    const {type} = char
    if (lists[type])
    lists[type].push(char)
  })
  return Reflect.ownKeys(lists).map(characteristicType => {
    const charList = lists[characteristicType]
    return <CharList key={characteristicType} agent={agent} editable={editable} characteristicType={characteristicType} charList={charList} localizationStore={localizationStore}/>
  })
})

export default CharLists;


// WEBPACK FOOTER //
// ./src/components/AgentInfo/components/CharLists/index.js